import lightredTheme from "../../../themes/lightredTheme";
import limegreenTheme from "../../../themes/limegreenTheme";
import moderatecyanTheme from "../../../themes/moderatecyanTheme";
import pureredTheme from "../../../themes/pureredTheme";
import strongblueTheme from "../../../themes/strongblueTheme";
import vividyellowTheme from "../../../themes/vividyellowTheme";

// themes
export const themes = [
   {
      id: 1,
      bgColor: "lightred",
      theme: lightredTheme
   },
   {
      id: 2,
      bgColor: "limegreen",
      theme: limegreenTheme
   },
   {
      id: 3,
      bgColor: "moderatecyan",
      theme: moderatecyanTheme
   },
   {
      id: 4,
      bgColor: "purered",
      theme: pureredTheme
   },
   {
      id: 5,
      bgColor: "strongblue",
      theme: strongblueTheme
   },
   {
      id: 6,
      bgColor: "vividyellow",
      theme: vividyellowTheme
   }
]


// WEBPACK FOOTER //
// ./src/store/modules/theme/data.js